import React from "react";
import Chart from "react-apexcharts";

export const AdminOccupancySection = ({
  selectedYear,
  selectedMonth,
  yearList = [],
  onHeatmapYearChange,
  onHeatmapMonthChange,
  occupancyLoading,
  occupancyError,
  occupancySeries = [],
  occupancyOptions,
  occupancySummary = {
    totalRooms: 0,
    occupiedRooms: 0,
    availableRooms: 0,
    bookingPercentage: 0,
  },
  heatmapLoading,
  heatmapError,
  heatmapSeries = [],
  heatmapOptions,
}) => {
  const monthLabels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  return (
    <div className="row g-3 mb-3">
      {/* <div className="col-12 col-xl-4">
        <div className="card">
          <div className="card-header">
            <h6 className="card-title mb-0">Room Occupancy Summary(Today)</h6>
          </div>
          <div className="card-body">
            {occupancyLoading && <p className="mb-0">Loading...</p>}
            {!occupancyLoading && occupancyError && (
              <p className="mb-0 text-muted">{occupancyError}</p>
            )}
            {!occupancyLoading && !occupancyError && occupancySeries.length > 0 && (
              <>
                <Chart
                  options={occupancyOptions}
                  series={occupancySeries}
                  type="pie"
                  height={300}
                />
                <div className="small text-muted mt-2">
                  Total: {occupancySummary.totalRooms} | Occupied: {occupancySummary.occupiedRooms} |
                  Available: {occupancySummary.availableRooms} | Booking: {occupancySummary.bookingPercentage}%
                </div>
              </>
            )}
          </div>
        </div>
      </div> */}

      <div className="col-12 col-xl-12">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h6 className="card-title mb-0">
              Hotel Occupancy Heatmap ({monthLabels[selectedMonth - 1]} {selectedYear})
            </h6>
            <div className="d-flex gap-2">
              <select
                className="form-select form-select-sm"
                style={{ width: "110px" }}
                value={selectedYear}
                onChange={onHeatmapYearChange}
              >
                {yearList.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
              <select
                className="form-select form-select-sm"
                style={{ width: "100px" }}
                value={selectedMonth}
                onChange={onHeatmapMonthChange}
              >
                {monthLabels.map((month, index) => (
                  <option key={month} value={index + 1}>
                    {month}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="card-body">
            {heatmapLoading && <p className="mb-0">Loading...</p>}
            {!heatmapLoading && heatmapError && (
              <p className="mb-0 text-muted">{heatmapError}</p>
            )}
            {!heatmapLoading && !heatmapError && heatmapSeries.length > 0 && (
              <div style={{ overflowX: "auto", overflowY: "hidden" }}>
                <Chart
                  options={heatmapOptions}
                  series={heatmapSeries}
                  type="heatmap"
                  height={Math.max(360, heatmapSeries.length * 30)}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
